import * as React from 'react';
import ReactSVG from 'react-svg'
import { bodyContent } from './constants'
import Expand from '../../../../../assets/images/applicants/landing_page/expand.svg'
import Collapse from '../../../../../assets/images/applicants/landing_page/collapse.svg'
import { ContractMenuKey, LocaleContent } from './types';

const { useState, useRef } = React;

const ContractMenu: Record<ContractMenuKey | 'UNSELECTED', number> = {
  UNSELECTED: -1,
  USA: 0,
  CA_EN: 1,
  CA_FR: 2,
}

const LocaleBody = ({ content, id, menuRef, contractMenuState, openMenu }: {
  content: LocaleContent;
  id: ContractMenuKey;
  menuRef: React.MutableRefObject<HTMLDivElement[]>;
  contractMenuState: number;
  openMenu: (selectedIndex: number) => void;
}) => (
  <div className="relative border-t border-kale">
    <div className="flex justify-between items-center" onClick={() => openMenu(ContractMenu[id])} role="button">
      <p className="my-7 lg:my-10">{content.title}</p>
      {contractMenuState === ContractMenu[id] ? <ReactSVG path={Collapse} /> : <ReactSVG path={Expand} />}
    </div>
    <div ref={el => { menuRef.current[ContractMenu[id]] = el }} className="overflow-hidden max-h-0">
      {content.body.map((section, i) => {
        return (
          <div key={i} className="paragraphs mb-12">
            <h2 className="mt-12 mb-3 lg:mb-5 font-heading font-medium text-mlg lg:text-hxl">{section.title}</h2>
            {section.paragraphs.map((value, y) => {
                return (
                  <p
                    key={y}
                    className="font-light mb-4 text-sm lg:text-lg"
                    dangerouslySetInnerHTML={{ __html: value }}
                  />
                )
            })}
          </div>
        )
      })}
    </div>
  </div>
)

export const Body = () => {
  const [contractMenuState, setContractMenuState] = useState<number>(ContractMenu.UNSELECTED)
  const menuRef = useRef<HTMLDivElement[]>([])

  const openMenu = (selectedIndex: number) => {
    const item = menuRef.current[selectedIndex]
    const h = item.scrollHeight === item.clientHeight ? '0' : item.scrollHeight
    setContractMenuState(prevIndex => (prevIndex !== selectedIndex ? selectedIndex : ContractMenu.UNSELECTED))
    menuRef.current.forEach((ref, menuRefIndex) => {
      menuRefIndex === selectedIndex ? (ref.style.maxHeight = `${h}px`) : (ref.style.maxHeight = '0px')
    });
  }

  const sharedLocaleProps = {
    menuRef,
    contractMenuState,
    openMenu,
  }

  return (
    <div className="contract-body py-10 lg:pb-24 lg:pt-32 m-auto lg:max-w-5xl text-kale text-base lg:text-xl">
      <h1 className="block text-mxl lg:text-6xl font-heading mb-9 pb-6">Contracts</h1>
      <LocaleBody {...sharedLocaleProps} id="USA" content={bodyContent.USA} />
      <LocaleBody {...sharedLocaleProps} id="CA_EN" content={bodyContent.CA_EN} />
      <LocaleBody {...sharedLocaleProps} id="CA_FR" content={bodyContent.CA_FR} />
    </div>
  )
}

